module.exports = __webpack_public_path__ + "static/media/ke.1c54a489.svg";